import React, { useState } from 'react';
import * as S from './styles';

const ChevronImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg';

interface AccordionProps {
  hasBorder?: boolean;
  isMultipleSelect?: boolean;
  handleOpen: () => void;
  externalContent: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  fixed?: boolean;
}

const Accordion = ({ hasBorder, externalContent, handleOpen, isOpen, children, fixed }: AccordionProps) => {
  return (
    <>
      <S.Container isOpen={isOpen} hasBorder={hasBorder}>
        <S.Row
          onClick={() => {
            !fixed ? handleOpen() : void 0;
          }}
        >
          {externalContent}
          {!fixed && (
            <>
              <div id={isOpen ? 'active' : 'not_active'} onClick={() => {}}>
                <img src={ChevronImg} alt="chevron" />
              </div>
            </>
          )}
        </S.Row>
        <S.DataListContainer isOpen={isOpen}>{children}</S.DataListContainer>
      </S.Container>
    </>
  );
};

export default Accordion;
